import './thesaurus-tree-node.scss'

import { ReactiveVue } from "@skinsoft/reactive-vue";
import Component from "vue-class-component";
import { ThesaurusTermTreeNode, thesaurusTermSelectors } from '@skinsoft/entity';
import { getTranslatedString } from '../../localized-string';
import {
    faCaretDown,
    faCaretRight
} from '@fortawesome/free-solid-svg-icons';

export interface ThesaurusTreeNodeSelected {
    selectedThesaurusTermId: string
}

export const THESAURUS_TREE_NODE_SELECTED = 'thesaurus-tree-node-selected'
export const THESAURUS_TREE_NODE_OPENED = 'thesaurus-tree-node-opened'

@Component({
    name: 's-thesaurus-tree-node',
    components: {
        sThesaurusTreeNode: ThesaurusTreeNode
    },
    props: ['thesaurusNode', 'selectedThesaurusTermId'],
    template: require('./thesaurus-tree-node.html')
})
export default class ThesaurusTreeNode extends ReactiveVue {
    private thesaurusNode: ThesaurusTermTreeNode
    private selectedThesaurusTermId: string

    private collapseIcon = faCaretRight;

    private THESAURUS_TREE_NODE_SELECTED = THESAURUS_TREE_NODE_SELECTED
    private THESAURUS_TREE_NODE_OPENED = THESAURUS_TREE_NODE_OPENED

    private get termTitle() {
        return getTranslatedString(thesaurusTermSelectors.preferredTerm(this.thesaurusNode.term), this.$i18n.locale)
    }

    private get termId() {
        return this.thesaurusNode.term.id
    }

    private get isSelected() {
        return this.selectedThesaurusTermId === this.thesaurusNode.term.id
    }

    private onTitleClicked() {
        this.$emit(THESAURUS_TREE_NODE_SELECTED, { selectedThesaurusTermId: this.thesaurusNode.term.id } as ThesaurusTreeNodeSelected)
    }

    private onCollapseIconClicked() {
        this.collapseIcon = this.collapseIcon === faCaretRight ? faCaretDown : faCaretRight
        if(this.collapseIcon === faCaretDown) {
            this.$emit(THESAURUS_TREE_NODE_OPENED, this.thesaurusNode)
        }
    }
}